import Search from '.';
import React from 'react';

class Area extends React.Component {
  render() {
    return <Search />;
  }
}
export default Area;
